module.exports = __webpack_public_path__ + "static/media/10.db6e9fc8.jpg";